// extracted by mini-css-extract-plugin
export var details = "_ef-0";
export var inspectorPopover = "_ef-1";